import Navigation from "@/components/Navigation"
import Footer from "@/components/Footer"
import { Button } from "@/components/ui/button"
import { Card, CardContent } from "@/components/ui/card"
import { Badge } from "@/components/ui/badge"
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { Input } from "@/components/ui/input"
import { Edit2, MoreHorizontal, Users, Camera, Plus, Sparkles } from "lucide-react"
import { useState } from "react"

const currentProjects = [
  {
    id: 1,
    name: "new carree oki",
    avatar: "/images/team/cedric.png",
    createdDate: "19/12/2024",
    members: 1,
    photos: 13,
    badges: ["Album commandé"],
    creations: [
      { id: 1, image: "/images/products/carre.png", format: "Carré (21x21cm)", pages: "34p" }
    ]
  },
  {
    id: 2,
    name: "new 20 premium",
    avatar: "/images/team/charlotte.png",
    createdDate: "07/05/2025",
    members: 1,
    photos: 15,
    badges: [],
    creations: [
      { id: 1, image: "/images/products/yearbook.png", format: "Carré (20x20cm) Premium", pages: "24p" }
    ]
  }
]

export default function SocialNetworks() {
  const [showWelcomeDialog, setShowWelcomeDialog] = useState(true)
  const [joinCode, setJoinCode] = useState("")

  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      
      {/* Welcome Dialog */}
      <Dialog open={showWelcomeDialog} onOpenChange={setShowWelcomeDialog}>
        <DialogContent className="max-w-4xl p-0 gap-0 overflow-hidden">
          <div className="grid md:grid-cols-[1.5fr,1fr]">
            {/* Créer un album - Section principale */}
            <div className="relative bg-gradient-to-br from-primary/10 via-secondary/10 to-accent/10 p-8 flex flex-col items-center justify-center">
              <div className="absolute top-4 right-4">
                <Badge className="bg-gradient-to-r from-primary to-secondary text-white border-0">
                  <Sparkles className="w-3 h-3 mr-1" />
                  Recommandé
                </Badge>
              </div>
              
              <DialogHeader className="text-center mb-6">
                <DialogTitle className="text-3xl font-display font-bold mb-2">
                  Créer un album
                </DialogTitle>
                <DialogDescription className="text-base">
                  Commencez votre projet et invitez vos proches
                </DialogDescription>
              </DialogHeader>

              <div className="mb-8 transform hover:scale-105 transition-transform">
                <img 
                  src="/images/products/carre.png" 
                  alt="Album example" 
                  className="w-64 h-64 object-cover rounded-2xl shadow-2xl ring-4 ring-primary/20"
                />
              </div>

              <Button 
                variant="rainbow" 
                size="lg" 
                className="w-full max-w-xs text-lg h-14"
                onClick={() => setShowWelcomeDialog(false)}
              >
                Créer mon album
              </Button>
            </div>

            {/* Rejoindre un groupe - Section secondaire */}
            <div className="bg-background p-8 flex flex-col justify-center border-l">
              <DialogHeader className="text-center mb-6">
                <DialogTitle className="text-xl font-display">
                  Rejoindre un groupe
                </DialogTitle>
                <DialogDescription className="text-sm">
                  Pour rejoindre un groupe, rentre ton code :
                </DialogDescription>
              </DialogHeader>

              <div className="space-y-4">
                <Input
                  placeholder="Code d'invitation"
                  value={joinCode}
                  onChange={(e) => setJoinCode(e.target.value)}
                  className="text-center text-lg h-12 border-2"
                />
                
                <Button 
                  variant="outline" 
                  size="lg" 
                  className="w-full"
                  onClick={() => setShowWelcomeDialog(false)}
                >
                  Rejoindre un album invité
                </Button>
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
      
      <main className="container mx-auto px-4 lg:px-8 py-8">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-4xl font-display font-bold mb-2 text-primary">Mes créations</h1>
          <p className="text-muted-foreground mb-8">Gérez vos projets d'albums photos</p>
          
          <div className="flex flex-wrap gap-4">
            <Button variant="rainbow" size="lg">
              Choisir un produit
            </Button>
            <Button variant="rainbow" size="lg">
              Rejoindre un album photos
            </Button>
          </div>
        </div>

        {/* Projets en cours */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {currentProjects.map((project) => (
            <Card key={project.id} className="border shadow-md hover:shadow-lg transition-shadow rounded-xl overflow-hidden">
              <CardContent className="p-0">
                {/* En-tête du projet */}
                <div className="bg-gradient-to-r from-background to-accent/20 p-6 border-b">
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-4">
                      <Avatar className="w-14 h-14 ring-2 ring-primary/20">
                        <AvatarImage src={project.avatar} alt={project.name} />
                        <AvatarFallback className="bg-gradient-to-br from-primary to-secondary text-white font-bold">
                          {project.name.charAt(0).toUpperCase()}
                        </AvatarFallback>
                      </Avatar>
                      <div>
                        <div className="flex items-center gap-2 mb-1">
                          <span className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse"></span>
                          <h3 className="font-bold text-xl text-foreground">{project.name}</h3>
                          <Edit2 className="w-4 h-4 text-muted-foreground cursor-pointer hover:text-primary transition-colors" />
                        </div>
                        <div className="flex items-center gap-4 text-sm text-muted-foreground">
                          <span>Créé le {project.createdDate}</span>
                          <span>• {project.members} Membre</span>
                          <span>• {project.photos} photos</span>
                        </div>
                      </div>
                    </div>
                    <MoreHorizontal className="w-5 h-5 text-muted-foreground cursor-pointer hover:text-foreground transition-colors" />
                  </div>
                  
                  <div className="flex gap-3">
                    <Button variant="outline" size="sm" className="bg-orange-50 text-orange-700 border-orange-200 hover:bg-orange-100">
                      <Camera className="w-4 h-4 mr-2" />
                      Vos photos
                    </Button>
                    <Button variant="outline" size="sm" className="bg-blue-50 text-blue-700 border-blue-200 hover:bg-blue-100">
                      <Users className="w-4 h-4 mr-2" />
                      Ajouter un membre
                    </Button>
                  </div>
                </div>

                {/* Contenu du projet */}
                <div className="p-6">
                  <h4 className="font-bold text-lg mb-4 text-foreground">Mes réalisations</h4>

                  <div className={`flex gap-4 ${project.creations.length === 1 ? 'justify-center' : 'justify-center'}`}>
                    {/* Créations existantes */}
                    {project.creations.map((creation) => (
                      <div key={creation.id} className="relative group">
                        <div className={`${project.creations.length === 1 ? 'w-48 h-48' : 'w-32 h-32'} rounded-xl overflow-hidden border-2 border-emerald-300 relative shadow-md group-hover:shadow-lg transition-shadow`}>
                          <img 
                            src={creation.image} 
                            alt="Album" 
                            className="w-full h-full object-cover"
                          />
                          {project.badges.includes("Album commandé") && (
                            <Badge className="absolute bottom-2 left-2 bg-emerald-500 text-white text-xs px-2 py-1 rounded-full">
                              Album commandé
                            </Badge>
                          )}
                        </div>
                        <div className="mt-3 text-xs text-center">
                          <div className="font-semibold text-primary">{creation.format}</div>
                          <div className="text-muted-foreground">{creation.pages}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                  
                  {/* Bouton ajouter un produit */}
                  <div className="mt-6 text-center">
                    <Button variant="outline" size="sm" className="text-xs">
                      <Plus className="w-3 h-3 mr-1" />
                      Ajouter un produit
                    </Button>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Section vide pour plus de projets */}
        <Card className="mt-12 border-2 border-dashed border-muted-foreground/30 rounded-xl hover:border-primary transition-colors">
          <CardContent className="p-12 text-center">
            <div className="mb-6">
              <Plus className="w-16 h-16 mx-auto mb-4 text-muted-foreground" />
              <h3 className="text-xl font-bold mb-2 text-foreground">Créer un nouveau projet</h3>
              <p className="text-muted-foreground">Commencez un nouvel album photo pour immortaliser vos souvenirs</p>
            </div>
            <Button variant="rainbow" size="lg">
              Nouveau projet
            </Button>
          </CardContent>
        </Card>
      </main>
      
      <Footer />
    </div>
  )
}